export default __webpack_public_path__ + "static/media/news-thumb6.85cecf3b.png";